import Vue from "vue";
import Router from "vue-router";
import { RouteConfig } from "vue-router";

Vue.use(Router);

const rs: RouteConfig[] = [
  {
    name: "/",
    path: "/",
    // component: () => import("@/portal/home/home")
    component: () => import("@/portal/index/index")
  },
  {
    name: 'home',
    path: '/home',
    component: () => import("@/portal/home/home")
  },
  // {
  //   name: 'pagetemplate',
  //   path: '/pagetemplate',
  //   component: () => import("@/portal/pagetemplate/pagetemplate")
  // }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: rs
});
export default router;
